import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '📙',
    title: 'Tomo 1 — Fuerza Base & Estabilidad',
    sessions: '61 sesiones',
    months: 'Meses 1 y 2',
    desc: 'Para construir cimientos sólidos y fuerza estructural en tus alumnos desde el primer día.',
    color: 'bg-[#FF6B00]',
    borderColor: 'border-t-[#FF6B00]'
  }, {
    emoji: '📘',
    title: 'Tomo 2 — Potencia & Transferencia Funcional',
    sessions: '61 sesiones',
    months: 'Meses 3 y 4',
    desc: 'Para desarrollar velocidad, explosividad y transferencia directa a gestos deportivos.',
    color: 'bg-[#3B82F6]',
    borderColor: 'border-t-[#3B82F6]'
  }, {
    emoji: '📕',
    title: 'Tomo 3 — Resistencia Metabólica & Fat Loss',
    sessions: '61 sesiones',
    months: 'Meses 5 y 6',
    desc: 'Para quemar grasa y llevar el acondicionamiento metabólico de tu grupo al límite.',
    color: 'bg-[#EF4444]',
    borderColor: 'border-t-[#EF4444]'
  }, {
    emoji: '📓',
    title: 'Tomo 4 — Hipertrofia Funcional',
    sessions: '61 sesiones',
    months: 'Meses 7 y 8',
    desc: 'Para ganar masa muscular de forma funcional con protocolos de hipertrofia adaptados.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '📗',
    title: 'Tomo 5 — Agilidad & Rendimiento Atlético',
    sessions: '61 sesiones',
    months: 'Meses 9 y 10',
    desc: 'Para mejorar la coordinación, agilidad y capacidad atlética general en cualquier nivel.',
    color: 'bg-[#10B981]',
    borderColor: 'border-t-[#10B981]'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — Especialización & Desafíos Finales',
    sessions: '60 sesiones',
    months: 'Meses 11 y 12',
    desc: 'Para poner a prueba todo lo aprendido en el año con desafíos y benchmarks competitivos.',
    color: 'bg-[#F59E0B]',
    borderColor: 'border-t-[#F59E0B]'
  }];
  const features = ['Objetivo del día claro y visible', 'Materiales con íconos visuales', 'Warm-up listo para dictar', 'Parte principal con series, reps y tiempos', '3 versiones: Principiante, Intermedio, Avanzado', 'Cool down específico de la sesión', 'Tip del Coach al final de cada hoja', 'Una sesión por página — sin hojas complicadas'];
  const featureChips = ['✅ Gym + Box + Funcional', '✅ Programa anual listo', '✅ Versiones A/B/C por nivel', '✅ Warm-ups y cool downs', '✅ 365 sesiones listas', '✅ Equipamiento básico'];
  return <Section className="bg-bg-base !pt-3 md:!pt-8" data-id="element-18">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-19">
        {/* Yellow trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-20">
          <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-3 py-1 md:px-3.5 md:py-1.5 rounded-full" style={{
          background: 'linear-gradient(135deg, #D4A41C 0%, #F0BE2A 50%, #D4A41C 100%)',
          color: '#1A1303',
          boxShadow: '0 0 20px rgba(212,164,28,0.4)'
        }} data-id="element-21">
            🏆 Sistema n°1 para profesores de Funcional
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase text-txt-primary mb-3 md:mb-4 md:text-[44px] text-[32px]" data-id="element-22">
          🏆 MEGAPACK FUNCIONAL <span className="text-brandOrange" data-id="element-23">365™</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-24">
          6 Tomos + 5 Bonos — 365 sesiones listas · Un año completo · Todo
          resuelto.
        </p>
      </FadeIn>

      {/* Colored book strip with emoji */}
      <FadeIn delay={0.2} className="mb-5 md:mb-8" data-id="element-25">
        <div className="flex justify-center gap-2 md:gap-4 px-2 md:px-0" data-id="element-26">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[44px] md:w-28 h-[60px] md:h-36 rounded-md md:rounded-lg shadow-lg flex flex-col items-center justify-center gap-0.5 md:gap-2 p-1 md:p-3 text-center text-white relative overflow-hidden transform hover:-translate-y-1 transition-transform border border-white/20`} data-id="element-27">
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-28"></div>
              <span className="font-sans font-bold uppercase tracking-[1px] text-[8px] md:text-[10px] leading-tight drop-shadow-md relative z-10" data-id="element-29">
                Tomo {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-3 md:mt-4" data-id="element-30">
          <span className="inline-block bg-brandOrange text-white font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full" data-id="element-31">
            6 TOMOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-32">
        <div className="flex flex-wrap justify-center gap-x-1 gap-y-1 md:gap-x-1.5 md:gap-y-1.5 max-w-3xl mx-auto" data-id="element-33">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandOrange/10 text-brandOrange border border-brandOrange/30 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[10px] whitespace-nowrap" data-id="element-34">
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.35} className="text-center mb-5 md:mb-7" data-id="element-35">
        <div className="inline-flex items-center gap-2 bg-bg-card border border-brandOrange/30 rounded-full px-4 py-1.5 md:px-5 md:py-2" data-id="element-36">
          <span className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] md:text-[13px] text-brandOrange" data-id="element-37">
            📦 Lo que recibís:
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 mb-12 md:mb-16" data-id="element-38">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        return <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-39">
              <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className={`w-full text-left bg-bg-card rounded-[16px] md:rounded-[20px] p-4 md:p-6 border-x border-b transition-all border-t-[3px] ${isOpen ? 'border-brandOrange shadow-[0_0_40px_rgba(255,107,0,0.2)]' : `border-x-line border-b-line ${tomo.borderColor}`}`} aria-expanded={isOpen} data-id="element-40">
                <div className="flex items-start justify-between gap-3" data-id="element-41">
                  <div className="flex items-start gap-2.5 md:gap-3 min-w-0 flex-1" data-id="element-42">
                    <div className="text-2xl md:text-4xl shrink-0" data-id="element-43">
                      {tomo.emoji}
                    </div>
                    <div className="min-w-0" data-id="element-44">
                      <h3 className="font-sans font-bold text-[15px] md:text-xl text-txt-primary leading-snug mb-1.5 md:mb-2" data-id="element-45">
                        {tomo.title}
                      </h3>
                      <div className="flex flex-wrap gap-1.5" data-id="element-46">
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandOrange bg-brandOrange/10 px-2 py-0.5 rounded" data-id="element-47">
                          {tomo.sessions}
                        </span>
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-txt-muted bg-white/5 px-2 py-0.5 rounded" data-id="element-48">
                          {tomo.months}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-brandOrange text-white rotate-180' : 'bg-bg-highlight text-txt-primary hover:bg-line'}`} data-id="element-49">
                    {isOpen ? <Minus size={14} data-id="element-50" /> : <Plus size={14} data-id="element-51" />}
                  </div>
                </div>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3 md:mt-4' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-52">
                  <div className="overflow-hidden" data-id="element-53">
                    <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-54">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </button>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-55">
        <div className="bg-bg-card rounded-[20px] p-5 md:p-10 border border-line max-w-4xl mx-auto" data-id="element-56">
          <h3 className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug mb-5 md:mb-8" data-id="element-57">
            Cada sesión incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2.5 md:gap-4" data-id="element-58">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-59">
                <CheckCircle2 className="text-success shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-60" />
                <span className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-61">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mt-6 md:mt-8 text-center" data-id="element-62">
            <p className="font-sans font-bold text-base md:text-xl text-brandOrange leading-snug" data-id="element-63">
              Abrís la sesión, leés 30 segundos y dictás. Así de simple. 365
              clases de alto rendimiento. Listas desde hoy.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🔧',
    title: 'Kit de Adaptaciones Rápidas',
    desc: 'Versión A, B y C para cada ejercicio. La misma clase para grupos mixtos.',
    value: '$12.000'
  }, {
    num: '02',
    icon: '🔥',
    title: 'Banco de 20 Warm-Ups Listos',
    desc: 'Calentamientos específicos por tipo de sesión. Express y completos.',
    value: '$10.000'
  }, {
    num: '03',
    icon: '🧊',
    title: 'Banco de 20 Cool Downs y Cierres',
    desc: 'Terminá cada clase con profesionalismo. Scripts de cierre incluidos.',
    value: '$10.000'
  }, {
    num: '04',
    icon: '🎤',
    title: '50 Frases y Scripts de Coaching',
    desc: 'Las palabras exactas para motivar, corregir y liderar tu clase.',
    value: '$9.000'
  }, {
    num: '05',
    icon: '📊',
    title: 'Planilla Maestra del Sistema',
    desc: 'Vista anual, mensual, semanal y diaria. Sin improvisar.',
    value: '$9.000'
  }];
  return <Section className="bg-bg-alt" data-id="element-64">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-65">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary mb-2 md:mb-4 text-[34px]" data-id="element-66">
          + 5 BONOS <span className="text-brandOrange" data-id="element-67">ESTRATÉGICOS</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-68">
          Incluidos en todas las ofertas — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-4 mb-8 md:mb-12" data-id="element-69">
        {bonuses.map((bono, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-70">
            <div className="bg-bg-card rounded-r-[12px] rounded-l-none p-3 md:p-4 border border-line border-l-[3px] border-l-brandOrange h-full relative overflow-hidden flex flex-col" data-id="element-71">
              <div className="absolute -right-1 -top-2 text-[48px] md:text-[64px] font-display font-black text-white/5 leading-none" data-id="element-72">
                {bono.num}
              </div>
              <div className="flex items-center justify-between gap-2 mb-1.5" data-id="element-73">
                <div className="flex items-center gap-1.5" data-id="element-74">
                  <span className="text-lg md:text-xl" data-id="element-75">🎁</span>
                  <div className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandOrange" data-id="element-76">
                    BONO {bono.num}
                  </div>
                </div>
                <span className="text-lg md:text-xl" data-id="element-77">{bono.icon}</span>
              </div>
              <h3 className="font-sans font-bold text-[13.5px] md:text-[15px] text-txt-primary leading-snug mb-1 md:mb-1.5" data-id="element-78">
                {bono.title}
              </h3>
              <p className="font-sans text-[12px] md:text-[13.5px] leading-[1.45] md:leading-[1.55] text-txt-body mb-2.5 md:mb-3" data-id="element-79">
                {bono.desc}
              </p>
              <div className="mt-auto pt-2 md:pt-2.5 border-t border-line flex items-center justify-between gap-2" data-id="element-80">
                <span className="font-sans font-normal text-[12px] md:text-[14px] line-through text-danger" data-id="element-81">
                  {bono.value}
                </span>
                <span className="bg-success text-white font-sans font-bold uppercase tracking-[1px] text-[8.5px] md:text-[10px] px-2 py-0.5 rounded-full" data-id="element-82">
                  GRATIS
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-bg-card p-5 md:p-8 rounded-[20px] border border-line max-w-2xl mx-auto" data-id="element-83">
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-84">
          Valor total de los 5 Bonos
        </p>
        <p className="font-sans font-normal text-[16px] md:text-[18px] line-through text-danger mb-2" data-id="element-85">
          $50.000
        </p>
        <p className="font-display font-black text-[24px] md:text-[44px] leading-[1.1] mb-1 md:mb-2 text-[#22C55E]" data-id="element-86">
          🎁 GRATIS — Solo con tu MEGAPACK
        </p>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-muted" data-id="element-87">
          Incluidos en todas las ofertas. Siempre.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden" data-id="element-88">
      <div className="max-w-[1100px] mx-auto" data-id="element-89">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-90">
          <div className="rounded-[20px] border-2 border-brandOrange p-6 md:p-10 text-center space-y-6 bg-bg-card max-w-lg mx-auto shadow-[0_0_50px_rgba(255,107,0,0.2),inset_0_0_30px_rgba(255,107,0,0.03)]" data-id="element-91">
            <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandOrange" data-id="element-92">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex justify-center gap-2.5 md:gap-4 text-white animate-glow-button" data-id="element-93">
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-94">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-95">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-96">
                  hs
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-brandOrange flex items-center" data-id="element-97">
                :
              </div>
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-98">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-99">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-100">
                  min
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-brandOrange flex items-center" data-id="element-101">
                :
              </div>
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-102">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-103">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-104">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 font-sans font-bold text-base md:text-xl text-gold leading-snug" data-id="element-105">
              <AlertTriangle size={20} data-id="element-106" />
              <span data-id="element-107">Después sube el precio. No vuelve.</span>
            </div>

            <div className="p-4 rounded-[14px] border border-line bg-bg-alt" data-id="element-108">
              <div className="flex justify-between font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-3" data-id="element-109">
                <span className="flex items-center gap-2" data-id="element-110">
                  <span className="w-2 h-2 rounded-full bg-brandOrange animate-pulse" data-id="element-111"></span>{' '}
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandOrange font-bold" data-id="element-112">Quedan pocos</span>
              </div>
              <div className="w-full bg-line rounded-full h-2 mb-2 overflow-hidden" data-id="element-113">
                <div className="bg-brandOrange h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-114"></div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted text-right" data-id="element-115">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const checkoutUrl = PRODUCTS[selected].checkoutUrl;
  const ctaText = selected === 'plus' ? 'SÍ, QUIERO EL SISTEMA COMPLETO' : 'SÍ, QUIERO EL MEGAPACK';
  return <Section className="bg-bg-alt" id="pricing" data-id="element-116">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-117">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary text-[40px]" data-id="element-118">
          Elegí tu <span className="text-brandOrange" data-id="element-119">MEGAPACK:</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] text-txt-body mt-2" data-id="element-120">
          Todas las opciones incluyen los 5 bonos estratégicos
        </p>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-4 md:space-y-5" data-id="element-121">
        {/* Option Plus - MÁS ELEGIDO (first) */}
        <FadeIn delay={0.1} data-id="element-122">
          <button onClick={() => setSelected('plus')} className={`w-full text-left rounded-[16px] md:rounded-[20px] p-3.5 md:p-6 transition-all duration-300 border-2 bg-bg-card relative ${selected === 'plus' ? 'border-brandOrange shadow-[0_0_50px_rgba(255,107,0,0.2),inset_0_0_30px_rgba(255,107,0,0.03)]' : 'border-line hover:border-gray-600'}`} data-id="element-123">
            {selected === 'plus' && <div className="absolute -top-2.5 left-1/2 transform -translate-x-1/2 text-white font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] px-2.5 md:px-3.5 py-0.5 md:py-1 rounded-full whitespace-nowrap bg-[#FF8C00]" data-id="element-124">
                ⭐ MÁS ELEGIDO
              </div>}
            <div className="flex items-start gap-2.5 md:gap-4" data-id="element-125">
              <div className={`w-4 h-4 md:w-6 md:h-6 rounded-full border-2 mt-0.5 md:mt-1 shrink-0 flex items-center justify-center ${selected === 'plus' ? 'border-brandOrange' : 'border-line'}`} data-id="element-126">
                {selected === 'plus' && <div className="w-2 h-2 md:w-3 md:h-3 rounded-full bg-brandOrange" data-id="element-127"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-128">
                <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1.5 md:mb-2" data-id="element-129">
                  <span className="text-base md:text-xl" data-id="element-130">🏆</span>
                  <h3 className="font-sans font-bold text-[13px] md:text-xl text-txt-primary leading-snug" data-id="element-131">
                    MEGAPACK +{' '}
                    <span className={`transition-colors ${selected === 'plus' ? 'text-brandOrange' : 'text-txt-primary'}`} data-id="element-132">
                      POTENCIADORES
                    </span>
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2 mb-1.5 md:mb-3" data-id="element-133">
                  <span className="bg-success/90 text-white font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-2 md:px-2.5 py-0.5 md:py-1 rounded-full" data-id="element-134">
                    AHORRÁS $22.000 🔥
                  </span>
                </div>
                <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.4] md:leading-[1.5] text-txt-body" data-id="element-135">
                  6 Tomos + 5 Bonos +{' '}
                  <span className={`font-bold transition-colors ${selected === 'plus' ? 'text-brandOrange' : 'text-txt-body'}`} data-id="element-136">
                    ✨ 6 Potenciadores de Especialización
                  </span>
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-137">
                <p className="font-sans font-normal text-[12px] md:text-[18px] line-through text-danger" data-id="element-138">
                  $49.990
                </p>
                <p className={`font-display font-black text-[24px] md:text-[52px] leading-none ${selected === 'plus' ? 'text-brandOrange' : 'text-txt-primary'}`} data-id="element-139">
                  $27.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Option Basic */}
        <FadeIn delay={0.2} data-id="element-140">
          <button onClick={() => setSelected('basic')} className={`w-full text-left rounded-[16px] md:rounded-[20px] p-3.5 md:p-6 transition-all duration-300 border-2 bg-bg-card ${selected === 'basic' ? 'border-brandOrange shadow-[0_0_50px_rgba(255,107,0,0.2),inset_0_0_30px_rgba(255,107,0,0.03)]' : 'border-line hover:border-gray-600'}`} data-id="element-141">
            <div className="flex items-start gap-2.5 md:gap-4" data-id="element-142">
              <div className={`w-4 h-4 md:w-6 md:h-6 rounded-full border-2 mt-0.5 md:mt-1 shrink-0 flex items-center justify-center ${selected === 'basic' ? 'border-brandOrange' : 'border-line'}`} data-id="element-143">
                {selected === 'basic' && <div className="w-2 h-2 md:w-3 md:h-3 rounded-full bg-brandOrange" data-id="element-144"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-145">
                <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1.5 md:mb-2" data-id="element-146">
                  <span className="text-base md:text-xl" data-id="element-147">📘</span>
                  <h3 className="font-sans font-bold text-[13px] md:text-xl text-txt-primary leading-snug" data-id="element-148">
                    MEGAPACK{' '}
                    <span className={`transition-colors ${selected === 'basic' ? 'text-brandOrange' : 'text-txt-primary'}`} data-id="element-149">
                      FUNCIONAL 365
                    </span>
                  </h3>
                </div>
                <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.4] md:leading-[1.5] text-txt-body" data-id="element-150">
                  6 Tomos Completos + 5 Bonos incluidos
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-151">
                <p className="font-sans font-normal text-[12px] md:text-[18px] line-through text-danger" data-id="element-152">
                  $34.990
                </p>
                <p className={`font-display font-black text-[24px] md:text-[52px] leading-none ${selected === 'basic' ? 'text-brandOrange' : 'text-txt-primary'}`} data-id="element-153">
                  $19.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Single CTA */}
        <FadeIn delay={0.3} data-id="element-154">
          <div className="pt-2 md:pt-4" data-id="element-155">
            <div className="text-center mb-2.5 md:mb-3" data-id="element-156">
              <p className="font-sans font-bold text-[12px] md:text-[14px] text-txt-primary leading-snug" data-id="element-157">
                👇 Tu próximo lunes empieza acá
              </p>
              <p className="font-sans text-[10.5px] md:text-[12px] text-brandOrange uppercase tracking-[1.5px] font-bold mt-1 animate-pulse" data-id="element-158">
                ⚡ Precio de lanzamiento — por tiempo limitado
              </p>
            </div>
            <CTAButton href={checkoutUrl} fullWidth trackingProduct={selected} data-id="element-159">
              {ctaText}
            </CTAButton>
            <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-3 md:mt-4 font-sans text-[11px] md:text-[13px] text-txt-muted" data-id="element-160">
              <span data-id="element-161">🔒 Pago 100% seguro</span>
              <span data-id="element-162">⚡ Acceso en 5 minutos</span>
              <span data-id="element-163">🛡️ Garantía 15 días</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const Potenciador = () => {
  const comparisons = [{
    bad: 'Das clases generales que cualquier coach puede dar',
    good: 'Te especializás en los 6 nichos más rentables del mercado'
  }, {
    bad: 'Cobrás lo que cobra cualquier instructor',
    good: 'Cobrás entre 2 y 4 veces más por clases especializadas'
  }, {
    bad: 'Tus alumnas de glúteos hacen los mismos ejercicios de siempre',
    good: '8 semanas de protocolo científico con resultados medibles'
  }, {
    bad: 'Tu grupo se estanca y empieza a faltar',
    good: 'Box Games convierte el grupo en comunidad que no abandona'
  }, {
    bad: 'El alumno con meseta no sabe por qué no avanza',
    good: 'Metabolic Overload rompe la meseta en 8 semanas'
  }];
  const volumes = [{
    icon: '🍑',
    title: 'Booty Builder',
    sub: 'Glúteos & Piernas de Élite',
    desc: 'Protocolo científico de tren inferior. Hip thrust, RDL, GVT de glúteo. Resultados en 4 semanas.'
  }, {
    icon: '⚡',
    title: 'Core & ABS Pro',
    sub: 'Protocolos Estrictos de Core',
    desc: 'Dragon flag, ab wheel, L-sit, McGill Big 3. Core visible que protege la columna.'
  }, {
    icon: '🏃',
    title: 'Performance Élite',
    sub: 'Entrenamiento para Deportistas',
    desc: 'Sprint, agilidad, potencia reactiva y RSA. Protocolos de preparadores profesionales.'
  }, {
    icon: '💥',
    title: 'Metabolic Overload',
    sub: 'Romper Mesetas Metabólicas',
    desc: 'Tabata, Wingate, AMRAP extremo y Density Training. EPOC máximo por sesión.'
  }, {
    icon: '🛡️',
    title: 'Injury Proof',
    sub: 'Movilidad y Prevención',
    desc: 'FMS, movilidad articular y propiocepción. Tus alumnos entrenan años sin lesionarse.'
  }, {
    icon: '🏆',
    title: 'Box Games',
    sub: 'Desafíos de Competición',
    desc: 'Relay, AMRAP competitivo, Championship y Gran Final. Tu grupo se vuelve familia.'
  }];
  return <Section className="bg-bg-base" data-id="element-164">
      <FadeIn className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-165">
        <h2 className="font-display font-extrabold uppercase text-[28px] md:text-[44px] leading-[1.1] text-txt-primary mb-4 md:mb-6" data-id="element-166">
          🚀 ¿QUÉ AGREGAN LOS{' '}
          <span className="text-brandOrange" data-id="element-167">POTENCIADORES?</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-168">
          El MEGAPACK resuelve el problema base. Los Potenciadores te dan{' '}
          <strong className="text-txt-primary" data-id="element-169">
            especialización en los 6 nichos más rentables del funcional.
          </strong>
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="max-w-6xl mx-auto mb-12 md:mb-16" data-id="element-170">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-8 md:mb-10" data-id="element-171">
          {volumes.map((vol, i) => <div key={i} className="bg-bg-card border border-line rounded-[14px] md:rounded-[16px] p-3 md:p-5 hover:border-brandOrange transition-all flex flex-col" data-id="element-172">
              <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-3" data-id="element-173">
                <div className="text-xl md:text-3xl shrink-0" data-id="element-174">{vol.icon}</div>
                <div className="min-w-0" data-id="element-175">
                  <h4 className="font-display font-black uppercase text-[15px] md:text-[22px] leading-[1.1] text-txt-primary mb-0.5" data-id="element-176">
                    {vol.title}
                  </h4>
                  <p className="font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[11px] text-brandOrange" data-id="element-177">
                    {vol.sub}
                  </p>
                </div>
              </div>
              <p className="font-sans text-[11.5px] md:text-[15px] leading-[1.45] md:leading-[1.6] text-txt-body mb-2.5 md:mb-4 flex-grow" data-id="element-178">
                {vol.desc}
              </p>
              <div className="bg-bg-highlight text-txt-body font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[11px] inline-block px-2 md:px-2.5 py-0.5 md:py-1 rounded-md self-start" data-id="element-179">
                42 sesiones · 8 semanas
              </div>
            </div>)}
        </div>

        <div className="bg-bg-card border border-brandOrange/30 rounded-[20px] p-5 md:p-8 text-center max-w-3xl mx-auto" data-id="element-180">
          <p className="font-display font-black uppercase text-[22px] md:text-[40px] leading-[1.15] text-brandOrange mb-1 md:mb-2" data-id="element-181">
            Total: 252 sesiones adicionales especializadas
          </p>
          <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-body" data-id="element-182">
            Llená tus clases de alto valor, potenciá la experiencia de tus
            alumnos y aumentá tus ingresos con estas herramientas.
          </p>
        </div>
      </FadeIn>

      <div className="max-w-4xl mx-auto" data-id="element-183">
        <div className="bg-bg-card rounded-[20px] overflow-hidden border border-line" data-id="element-184">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5 text-center" data-id="element-185">
            <div className="font-sans font-bold text-[13px] md:text-[16px] text-txt-muted" data-id="element-186">
              ❌ Sin Potenciadores
            </div>
            <div className="font-sans font-bold text-[13px] md:text-[16px] text-success" data-id="element-187">
              ✅ Con Potenciadores
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-188">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5" data-id="element-189">
                <div className="font-sans text-[12px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-muted pr-2 md:pr-4" data-id="element-190">
                  {row.bad}
                </div>
                <div className="font-sans text-[12px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-primary pl-2 md:pl-4 border-l border-line" data-id="element-191">
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
};